export function blankToNull<T>(value: T | undefined | ''): null | T {
  return value === '' || value === undefined ? null : value;
}

export function nullToUndefined<T>(value: T | null): T | undefined {
  return value ?? undefined;
}

export function createValueToLabelMap<T extends Record<string, number | string>>(obj: T, value: T[keyof T]): keyof T | undefined {
  return Object.entries(obj).find(([_, v]) => v === value)?.[0] as keyof T | undefined;
}

export function parseBoolean(value: string | boolean | null | undefined): boolean {
  if (typeof value === 'boolean') return value;
  return value === 'true';
}
